<template>
  <div class="grid grid-cols-5 gap-6">
    <slot>
      <DataPoint v-if="data" v-for="key in Object.keys(data)">
        {{ key }}
        <template #value>{{ data[key] }}</template>
      </DataPoint>
    </slot>
  </div>
</template>

<script lang="ts" setup>
type Props = {
  data?: any;
};
const props = withDefaults(defineProps<Props>(), {
  data: {},
});
</script>
